import type React from 'react';

import { Button } from '../Input2';

import Popup, { type PopupProps } from './Popup';

type WarningPopupProps = PopupProps & {
  title: string;
  message: string | React.ReactNode;
};

export default function WarningPopup({ message, title, onClose }: WarningPopupProps) {
  return (
    <Popup onClose={onClose}>
      <h2 className="text-center text-lg font-bold">
        <span className="text-base">⚠️</span> {title}
      </h2>
      <p>{message}</p>
      <Button color="blue" onClick={onClose}>
        Okay
      </Button>
    </Popup>
  );
}

